import { useMutation } from "@tanstack/react-query";
import i18n from "@/i18n";
import { api } from "@/lib/api";

/** The global template's own download, next to but separate from a version's (ADR-0071). */
export const templateHref = "/api/beheer/wedstrijdboekjes/template";

/** The API answers RFC 7807, so a refusal carries a Dutch sentence the beheerder can act on. */
function problem(error: unknown, response: Response, fallback: string) {
  const title = (error as { title?: string } | undefined)?.title;
  return new Error(title ?? `${fallback} (${response.status}).`);
}

export function useUploadTemplate() {
  return useMutation({
    mutationFn: async (bestand: File) => {
      const body = new FormData();
      body.set("bestand", bestand);

      const { error, response } = await api.POST("/api/beheer/wedstrijdboekjes/template", {
        // @ts-expect-error openapi-fetch types this path as JSON; FormData skips serialisation
        // and lets the browser set the multipart boundary, which is what the Api actually reads.
        body,
      });
      if (!response.ok) {
        throw problem(error, response, i18n.t("wedstrijdboekjes:errors.sjabloonUploaden"));
      }
    },
  });
}
